import React from 'react';
import {MaintenanceHistory} from '../organisms/MaintenanceHistory';

const MaintenanceHistoryPage = () => {
  return (
    <div
      style={{
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <MaintenanceHistory />
    </div>
  );
};

export default MaintenanceHistoryPage;
